const n = {
  container: {
    flexDirection: "column"
  },
  titleText: {
    color: "#808080"
  },
  contentContainer: {
    flexDirection: "column",
    gap: 1
  },
  statusTextContainer: {
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: 1,
    alignItems: "center",
    width: "auto"
  },
  warningIcon: {
    color: (t) => t.vars?.palette.warning.light ?? t.palette.warning.light,
    fontSize: "1rem",
    mb: 0.5
  },
  extraContent: {
    gap: 2,
    flexWrap: "nowrap",
    width: "auto"
  }
};
export {
  n as styles
};
